import React from 'react'

export type Device = 'desktop' | 'tablet' | 'mobile'

export const DeviceContext = React.createContext<Device>('desktop')

export function useDevice() {
  const device = React.useContext(DeviceContext)
  return {
    device,
    cols: (desktopCols: number): number => {
      if (device === 'mobile') return 1
      if (device === 'tablet') return Math.min(2, desktopCols)
      return desktopCols
    },
    isMobile: device === 'mobile',
    isTablet: device === 'tablet',
  }
}
